const TrackingLine = ({ type = "formal", index = 0, isVisible = false }) => {
    const colors = {
        formal: {
            dot: 'from-blue-500 to-indigo-600',
            ring: 'border-blue-300',
            glow: 'shadow-blue-400/30'
        },
        nonformal: {
            dot: 'from-indigo-500 to-purple-600', 
            ring: 'border-indigo-300',
            glow: 'shadow-indigo-400/30'
        }
    };

    const currentColors = colors[type] || colors.formal;
    
    return(
        <div className="flex flex-col items-center relative">
            {/* Main tracking dot */}
            <div className={`relative w-4 h-4 rounded-full bg-slate-900 dark:bg-slate-400 
                            transition-all duration-300 transform
                            ${isVisible ? 'scale-100 opacity-100' : 'scale-90 opacity-70'}
                            hover:scale-110`}>
            </div>
            
            {/* Connecting line */}
            <div className={`w-px flex-1 bg-slate-300 dark:bg-slate-700 
                           transition-all duration-500 transform origin-top mt-2
                           ${isVisible ? 'scale-y-100' : 'scale-y-0'}`}>
            </div>
        </div>
    )
}
export default TrackingLine;